import { queue } from "d3-queue";
import { json } from "d3-request";
import * as d3 from "d3";
import socioEconomic from "../../../../data/socioEconomic";

const renderMap = (data) => {
  const chicago_boundary =
    "https://suntimes-graphics.s3.amazonaws.com/shapefiles/community-areas.geojson";

  queue().defer(json, chicago_boundary).await(loaded);

  function loaded(error, chicago) {
    d3.select("#homicide_map_key svg svg").remove();

    d3.select("#covid_salestax_map svg svg").remove();
    d3.select("#covid_salestax_map .tool_tip").remove();
    d3.select("#homicide_map_buttons .total_homicides").on(
      "click",
      renderTotalhomicides
    );
    d3.select("#homicide_map_buttons .per_capita").on("click", renderPerCapita);

    data = data.sort((a, b) => (b.communityarea < a.communityarea ? 1 : -1));

    const newData = {};
    for (let i = 0; i < data.length; i++) {
      if (newData[data[i].communityarea.toLowerCase().split("/")[0]]) {
        newData[data[i].communityarea.toLowerCase().split("/")[0]] = ++newData[
          data[i].communityarea.toLowerCase().split("/")[0]
        ];
      } else {
        newData[data[i].communityarea.toLowerCase().split("/")[0]] = 1;
      }
    }

    const test = Object.keys(newData).map((d) => {
      const t = socioEconomic.filter(
        (o) =>
          o.name
            .toLowerCase()
            .split("'")
            .join("")
            .split(" ")
            .join("")
            .trim() ===
          d.toLowerCase().split("'").join("").split(" ").join("").trim()
      );
      return {
        neighborhood: d,
        val: newData[d],
        ratio: (newData[d] / +t[0].population) * 10000,
      };
    });

    const color = d3
      .scaleLinear()
      .domain([
        0,
        d3.max(test, (d) => d.ratio) * 0.25,
        d3.max(test, (d) => d.ratio) * 0.5,
        d3.max(test, (d) => d.ratio) * 0.75,
        d3.max(test, (d) => d.ratio),
      ])
      .range(["#eae29c", "#e9ad64", "#f28c4b", "#d25129", "#861619"]);

    const radius = d3
      .scaleSqrt()
      .domain([0, d3.max(test, (d) => d.val)])
      .range([0, 25]);

    const x = d3
      .scaleLinear()
      .domain([0, d3.max(test, (d) => d.val)])
      .range([20, 400]);

    const width = 600,
      height = 800,
      projection = d3.geoMercator(),
      path = d3.geoPath().projection(projection);

    const svg = d3
      .select("#covid_salestax_map .map_container")
      .append("svg")
      .attr("width", width)
      .attr("height", height);

    const key = d3
      .select("#homicide_map_key svg")
      .append("svg")
      .attr("width", 600)
      .attr("height", 80);

    const tooltip = d3.select("body").append("div").attr("class", "tool_tip");

    projection.scale(1).translate([0, 0]);
    const b = path.bounds(chicago),
      s =
        0.99 /
        Math.max((b[1][0] - b[0][0]) / width, (b[1][1] - b[0][1]) / height),
      t = [
        (width - s * (b[1][0] + b[0][0])) / 2,
        (height - s * (b[1][1] + b[0][1])) / 2,
      ];
    projection.scale(s).translate(t);

    function renderPerCapitaKey() {
      const maxValue = d3.max(test, (d) => d.ratio).toFixed(0);
      d3.select("#homicide_map_key").style("display", "none");
      d3.select("#per_capita_key").style("display", "grid");
      d3.select("#perPersonMax").text(maxValue);
    }

    function renderTotalHomicideKey() {
      d3.select("#homicide_map_key").style("display", "grid");
      d3.select("#per_capita_key").style("display", "none");
    }

    const perCapitaMap = svg.append("g").attr("id", "per_capita_map");

    const totalHomicideMap = svg.append("g").attr("id", "total_homicide_map");

    const overlay = svg.append("g").attr("id", "map_overlay");

    perCapitaMap
      .append("g")
      .selectAll("path")
      .data(chicago.features)
      .enter()
      .append("path")
      .attr("d", path)
      .attr("fill", "rgba(0,0,0,0)")
      .attr("stroke-width", 0.5)
      .attr("stroke", "#fff");

    totalHomicideMap
      .append("g")
      .selectAll("circle")
      .data(chicago.features)
      .enter()
      .append("circle")
      .attr(
        "class",
        (d) => `${d.properties.community.toLowerCase().split(" ").join("")}`
      )
      .attr("transform", (d) => "translate(" + path.centroid(d) + ")");

    let mode;

    function renderPerCapita() {
      key.html("");
      renderPerCapitaKey();
      mode = "perCapita";
      totalHomicideMap.attr("display", "none");
      perCapitaMap
        .selectAll("path")
        .attr("fill", (d) => {
          const t = socioEconomic.filter(
            (o) =>
              o.name.toLowerCase().split("'").join("") ===
              d.properties.community.toLowerCase()
          );
          return (
            color(
              (newData[d.properties.community.toLowerCase()] /
                +t[0].population) *
                10000
            ) || "#efefef"
          );
        })
        .attr("stroke", "#fff")
        .attr("stroke-width", 0.75);
    }

    function renderTotalhomicides() {
      key.html("");
      renderTotalHomicideKey();
      mode = "totalHomicides";
      perCapitaMap.selectAll("path").attr("fill", "#efefef");
      totalHomicideMap.attr("display", "block");
      totalHomicideMap
        .selectAll("circle")
        .data(chicago.features)
        .attr("r", function (d) {
          const t = socioEconomic.filter(
            (o) =>
              o.name.toLowerCase().split("'").join("") ===
              d.properties.community.toLowerCase()
          );
          return radius(newData[d.properties.community.toLowerCase()]);
        })
        .attr("fill", "red")
        .attr("fill-opacity", 0.4)
        .attr("stroke", "red");
    }

    renderTotalhomicides();

    overlay
      .append("g")
      .selectAll("path")
      .data(chicago.features)
      .enter()
      .append("path")
      .attr("d", path)
      .attr(
        "class",
        (d) => `${d.properties.community.toLowerCase().split(" ").join("")}`
      )
      .attr("fill", "rgba(0,0,0,0)")
      .attr("stroke", "rgba(0,0,0,0)")
      .on("mouseleave", (event, d) => {
        tooltip.style("display", "none");
        if (mode === "totalHomicides") {
          d3.select(
            `#total_homicide_map .${d.properties.community
              .toLowerCase()
              .split(" ")
              .join("")}`
          )
            .attr("stroke", "red")
            .attr("fill-opacity", 0.4);
        } else {
          d3.select(
            `#map_overlay .${d.properties.community
              .toLowerCase()
              .split(" ")
              .join("")}`
          ).attr("stroke", "");
        }
      })
      .on("mousemove", (event, d) => {
        const w = window.innerWidth;

        const t = socioEconomic.filter(
          (o) =>
            o.name.toLowerCase().split("'").join("") ===
            d.properties.community.toLowerCase()
        );

        const tooltip_w = tooltip.node().getBoundingClientRect().width;

        const perCapita = (
          (newData[d.properties.community.toLowerCase()] / +t[0].population) *
          10000
        ).toFixed(1);
        tooltip.style("display", "block");
        tooltip.html(
          `<div><p class="community_name">${toTitleCase(
            d.properties.community
          )}</p>
        <p>${newData[d.properties.community.toLowerCase()] || 0} homicides</p>
        <p>${isNaN(perCapita) ? 0 : perCapita} homicides per 10,000</p></div>`
        );

        tooltip.style("top", event.pageY + 10 + "px");
        event.pageX < w / 1.5
          ? tooltip.style("left", event.pageX + 10 + "px")
          : tooltip.style("left", event.pageX - tooltip_w - 10 + "px");

        if (mode === "perCapita") {
          d3.select(
            `.circle${d.properties.community.toLowerCase().split(" ").join("")}`
          ).attr("stroke", "#333");
        }
        if (mode === "totalHomicides") {
          d3.select(
            `#total_homicide_map .${d.properties.community
              .toLowerCase()
              .split(" ")
              .join("")}`
          )
            .attr("stroke", "#333")
            .attr("fill-opacity", 0.7);
        } else {
          d3.select(
            `#map_overlay .${d.properties.community
              .toLowerCase()
              .split(" ")
              .join("")}`
          ).attr("stroke", "#333");
        }
      });
  }
};

function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export default renderMap;
